/**
 * Only real secure-id values should be sent; omit false, empty, or the literal "false".
 */
export function isValidSecureIdHeaderValue(value) {
  if (value === undefined || value === null || value === false) {
    return false
  }
  const s = typeof value === "string" ? value.trim() : String(value).trim()
  if (!s || s.toLowerCase() === "false") {
    return false
  }
  return true
}

/**
 * @returns {Record<string, string>} headers object with secure-id, or {} if none should be sent
 */
export function secureIdHeadersFromValue(secureId) {
  if (!isValidSecureIdHeaderValue(secureId)) {
    return {}
  }
  const s = typeof secureId === "string" ? secureId.trim() : String(secureId)
  return { "secure-id": s }
}

/**
 * Removes invalid secure-id from axios request config (mutates).
 */
export function omitInvalidSecureIdHeader(config) {
  if (!config.headers) {
    return
  }
  const strip = (headers) => {
    if (!headers || typeof headers !== "object") {
      return
    }
    Object.keys(headers).forEach((key) => {
      if (key.toLowerCase() === "secure-id" && !isValidSecureIdHeaderValue(headers[key])) {
        delete headers[key]
      }
    })
  }
  strip(config.headers)
  strip(config.headers.common)
}
